import React, { useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, notification } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";

const ExportMeeting = ({ meeting, attendees = [] }) => {
  const [loadingExcel, setLoadingExcel] = useState(false);

  const exportToExcel = async () => {
    try {
      // ✅ validar objeto
      if (!meeting) {
        notification.warning({
          message: "Advertencia",
          description: "No hay información de la reunión para exportar.",
        });
        return;
      }

      setLoadingExcel(true);

      const workbook = new ExcelJS.Workbook();
      let worksheet;

      /* ==============================
         CARGAR PLANTILLA (SI EXISTE)
      ============================== */
      try {
        const templateResponse = await fetch(
          "/assets/Plantilla_Listado_de_Asistencia_V3.xlsx"
        );

        if (!templateResponse.ok) throw new Error();

        const templateBuffer = await templateResponse.arrayBuffer();
        await workbook.xlsx.load(templateBuffer);

        worksheet = workbook.worksheets[0]; // 🔥 más seguro

      } catch {
        console.log("Usando hoja nueva sin plantilla");
      }


      /* ==============================
         DATOS REUNIÓN
      ============================== */
worksheet.getCell("C3").value = meeting.fecha;
worksheet.getCell("G3").value = meeting.horaInicio;
worksheet.getCell("J3").value = meeting.horaFinalizacion;
worksheet.getCell("L3").value = meeting.facilitador;
worksheet.getCell("L4").value = meeting.lugar;
worksheet.getCell("C4").value = meeting.tema;

      /* ==============================
         ASISTENTES
      ============================== */
            let currentRow = 8;
            let row = 0;

  if (attendees.length > 0) {
          attendees.forEach((participante) => {
            if (participante && typeof participante === "object") {
              row++;

              worksheet.getCell(`B${currentRow}`).value = row;
              worksheet.mergeCells(`C${currentRow}:E${currentRow}`);
              worksheet.getCell(`C${currentRow}`).value = participante.nombresApellidos || "";

              worksheet.mergeCells(`F${currentRow}:G${currentRow}`);
              worksheet.getCell(`F${currentRow}`).value =participante.telefono || "";

              worksheet.mergeCells(`H${currentRow}:I${currentRow}`);
              worksheet.getCell(`H${currentRow}`).value =participante.correo || "";

              worksheet.mergeCells(`J${currentRow}:K${currentRow}`);
              worksheet.getCell(`J${currentRow}`).value =participante.tipoEntidad || "";

              worksheet.getCell(`L${currentRow}`).value =participante.planta === "contratista" ? "X" : "";
              worksheet.getCell(`N${currentRow}`).value =participante.planta === "directivo" ? "X" : "";
              worksheet.getCell(`P${currentRow}`).value =participante.planta === "asesor" ? "X" : "";
              worksheet.getCell(`R${currentRow}`).value = participante.planta === "profesional" ? "X" : "";
              worksheet.getCell(`T${currentRow}`).value = participante.planta === "tecnico" ? "X" : "";
              worksheet.getCell(`V${currentRow}`).value =participante.planta === "asistencial" ? "X" : "";

              worksheet.mergeCells(`X${currentRow}:AA${currentRow}`);

            }
            currentRow++; // Avanzar fila
          });
        }
    

      /* ==============================
         EXPORTAR
      ============================== */
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileName = `Reunion_${meeting.codigo || "sin_codigo"}_${
        meeting.fecha || ""
      }.xlsx`;

      saveAs(blob, fileName);

      notification.success({
        message: "Exportación exitosa",
        description: `Archivo ${fileName} descargado correctamente.`,
      });

    } catch (error) {
      console.error("Error al exportar:", error);

      notification.error({
        message: "Error",
        description: "No se pudo generar el archivo Excel.",
      });

    } finally {
      setLoadingExcel(false);
    }
  };

  return (
    <Button
      type="default"
      icon={<FileExcelOutlined />}
      onClick={exportToExcel}
      loading={loadingExcel}
      size="small"
    >
      Excel
    </Button>
  );
};

export default ExportMeeting;
